"use client";

import * as m from "motion/react-m";
import type { ReactNode } from "react";

interface Props {
	children: ReactNode;
	as?: "div" | "li";
	// Задержка в секундах: соседние блоки выезжают по очереди
	delay?: number;
	// Внутри RevealGroup блок не следит за экраном сам, а появляется вместе с группой
	inGroup?: boolean;
	className?: string;
}

interface GroupProps {
	children: ReactNode;
	className?: string;
}

const TAGS = { div: m.div, li: m.li };
// Блок начинает появляться заранее, за 120px до края экрана. Иначе при медленной
// прокрутке сначала видна пустая полоса секции, а на iPhone ещё и зона под панелью
// браузера, которую страница уже показывает, но экраном не считает
const VIEWPORT = {
	once: true,
	amount: "some" as const,
	margin: "0px 0px 120px 0px",
};

// Блок выезжает снизу и проявляется, когда до него долистали. Один раз
export default function Reveal({
	children,
	as = "div",
	delay = 0,
	inGroup = false,
	className,
}: Props) {
	const Tag = TAGS[as] as typeof m.div;

	return (
		<Tag
			data-reveal
			variants={{
				hidden: { opacity: 0, y: 32 },
				shown: {
					opacity: 1,
					y: 0,
					transition: { duration: 1, ease: [0.33, 1, 0.68, 1], delay },
				},
			}}
			{...(!inGroup && {
				initial: "hidden",
				whileInView: "shown",
				viewport: VIEWPORT,
			})}
			className={className}
		>
			{children}
		</Tag>
	);
}

// Показывает все вложенные Reveal с inGroup разом, когда до группы долистали.
// Нужна там, где блоки могут быть скрыты за краем, например в ленте слайдера
export function RevealGroup({ children, className }: GroupProps) {
	return (
		<m.div
			initial="hidden"
			whileInView="shown"
			viewport={VIEWPORT}
			className={className}
		>
			{children}
		</m.div>
	);
}
